import { gql } from 'graphql-tag';
import { useQuery } from '@apollo/client';

export const VALIDATE_INVOICE_AMOUNT_LIMIT = gql`
  query validateInvoiceAmountLimit($id: String!) {
    validateInvoiceAmountLimit(id: $id) {
      success
      failedLineItems {
        project {
          id
          displayText
        }
        projectTCVAmount {
          amount
          currency {
            symbol
            displayText
          }
        }
        exceededBillAmount {
          amount
          currency {
            symbol
            displayText
          }
        }
      }
    }
  }
`;
export const useValidateInvoiceAmountLimit = id => {
  const { data, loading } = useQuery(VALIDATE_INVOICE_AMOUNT_LIMIT, {
    variables: { id },
    fetchPolicy: 'network-only'
  });

  return {
    data,
    loading
  };
};

export default useValidateInvoiceAmountLimit;
